import styles from "./StudyStatusIcon.css";
import PropTypes from "prop-types";
import * as React from "react";

const StudyStatusIcon = ({ status }) => {
	return (
		<><span className={styles.statusIcon}>&#x25cf;</span> {status} </>
	);
};

StudyStatusIcon.propTypes = {
	status: PropTypes.string
};

export default StudyStatusIcon;